import request from "../utils/request";
import {praseStrEmpty} from "../utils/treating";
import store from "@/store/index.js"
import axios from "axios";
// --------------------登录页面--------------------
// 获取短信验证

export const sendPhoneCodeAjax = data => {
    return request({
        method: "GET",
        url: "/wx/sendPhoneCode/",
        params: data
    });
};
export const restPwd = data => {
    return request({
        method: "post",
        url: "/system/user/restPwd",
        data
    });
};
//获取验证码
export const VerificationAjax = () => {
    return request({
        method: "GET",
        url: "/captchaImage"
    });
};
//登录接口
export const LoginAjax = data => {
    return request({
        method: "POST",
        url: "/login",
        data
    });
};

// --------------------home页面--------------------
//获取用户信息
export const InfoAjax = () => {
    return request({
        method: "GET",
        url: "/getInfo"
    });
};
//获取用户路由信息
export const RoutersAjax = () => {
    return request({
        method: "GET",
        url: "/getRouters"
    });
};
// 修改密码
export const updatePwd = data => {
    return request({
        url: "/system/user/profile/updatePwd",
        method: "PUT",
        data: data
    });
};
// --------------------部门管理--------------------
// 获取表单数据
export const DeptListsAjax = data => {
    return request({
        method: "GET",
        url: "/system/dept/list",
        params: data
    });
};

// 新增部门
export const addDept = data => {
    return request({
        url: "/system/dept",
        method: "post",
        data: data
    });
};
// 修改部门状态
export const DeptchangeStatus = data => {
    return request({
        url: "/system/dept/changeStatus",
        method: "PUT",
        data: data
    });
};
// 查询部门详细
export const getDept = deptId => {
    return request({
        url: "/system/dept/" + deptId,
        method: "get"
    });
};
// 修改部门
export const updateDept = data => {
    return request({
        url: "/system/dept",
        method: "put",
        data: data
    });
};
// 删除部门
export const DeptDeleteAjax = data => {
    return request({
        method: "DELETE",
        url: "/system/dept/" + data
    });
};

// --------------------角色管理--------------------
// 获取表单数据
export const RoleListsAjax = data => {
    return request({
        method: "GET",
        url: "/system/role/list",
        params: data
    });
};
// 查询角色详细
export const getRole = roleId => {
    return request({
        url: "/system/role/" + roleId,
        method: "GET"
    });
};
// 新增角色
export const addRole = data => {
    return request({
        url: "/system/role",
        method: "post",
        data: data
    });
};
// 修改角色状态;
export const changeRoleStatus = (roleId, status) => {
    const data = {
        roleId,
        status
    };
    return request({
        url: "/system/role/changeStatus",
        method: "put",
        data: data
    });
};
// 修改角色
export const updateRole = data => {
    return request({
        url: "/system/role",
        method: "put",
        data: data
    });
};
// 角色数据权限
export const dataScope = data => {
    return request({
        url: "/system/role/dataScope",
        method: "put",
        data: data
    });
};
// 获取新增按钮数据
export const RoleTreeselectAjax = data => {
    return request({
        method: "GET",
        url: "/system/menu/treeselect",
        params: data
    });
};
// 获取新增按钮数据
export const roleDeptTreeselect = roleId => {
    return request({
        url: "/system/dept/roleDeptTreeselect/" + roleId,
        method: "get"
    });
};

// 删除部门
export const RoleDeleteAjax = data => {
    return request({
        method: "DELETE",
        url: "/system/role/" + data
    });
};

// --------------------菜单管理--------------------
// 获取表单数据
export const MenuListsAjax = data => {
    return request({
        method: "GET",
        url: "/system/menu/list",
        params: data
    });
};
// 查询菜单详细
export const getMenu = menuId => {
    return request({
        url: "/system/menu/" + menuId,
        method: "get"
    });
};
// 根据角色ID查询菜单下拉树结构
export const roleMenuTreeselect = roleId => {
    return request({
        url: "/system/menu/roleMenuTreeselect/" + roleId,
        method: "get"
    });
};
//新增菜单
export const addMenu = data => {
    return request({
        url: "/system/menu",
        method: "POST",
        data: data
    });
};
// 菜单状态修改
export const changeMenuStatus = (menuId, status) => {
    const data = {
        menuId,
        status
    };
    return request({
        url: "/system/menu/changeStatus",
        method: "put",
        data: data
    });
};
// 修改菜单
export const updateMenu = data => {
    return request({
        url: "/system/menu",
        method: "PUT",
        data: data
    });
};
// 删除菜单
export const MenuDeleteAjax = data => {
    return request({
        method: "DELETE",
        url: "/system/menu/" + data
    });
};

// --------------------用户管理--------------------
// 获取表单列表
export const UserListsAjax = data => {
    return request({
        method: "GET",
        url: "/system/user/list",
        params: data
    });
};

export function UserListZw(params) {
    //员工通讯录查询 - 职位
    return request({
        method: "GET",
        url: "/system/user/getUserPostList",
        params
    })
}

// 新增用户
export const AddUserListsAjax = data => {
    return request({
        method: "post",
        url: "/system/user",
        data: data
    });
};
// 查询用户详细
export const getUser = userId => {
    return request({
        url: "/system/user/" + praseStrEmpty(userId),
        method: "get"
    });
};
// 修改用户
export const updateUser = data => {
    return request({
        url: "/system/user",
        method: "put",
        data: data
    });
};
//树形结构数据
// export const TreeselectListsAjax = data => {
//   return request({
//     method: "GET",
//     url: "/system/dept/treeselect",
//     params: data
//   });
// };
export const TreeselectListsAjax = data => {
    return request({
        method: "GET",
        url: "/system/dept/treeselectDataScope",
        params: data
    });
};
//删除员工
export const UserDeleteAjax = data => {
    return request({
        method: "DELETE",
        url: "/system/user/" + data
    });
};

// 用户密码重置
export function resetUserPwd(userId, password) {
    const data = {
        userId,
        password
    };
    return request({
        url: "/system/user/resetPwd",
        method: "put",
        data: data
    });
}

// --------------------岗位管理------------------------
//获取岗位表单
export const PostListsAjax = data => {
    return request({
        method: "GET",
        url: "/system/post/list",
        params: data
    });
};
// 查询岗位详细
export const getPost = postId => {
    return request({
        url: "/system/post/" + postId,
        method: "get"
    });
};

// 新增岗位
export const AddPostAjax = data => {
    return request({
        method: "post",
        url: "/system/post",
        data: data
    });
};
// 修改岗位
export const updatePost = data => {
    return request({
        url: "/system/post",
        method: "put",
        data: data
    });
};
//删除岗位
export const PostDeleteAjax = data => {
    return request({
        method: "DELETE",
        url: "/system/post/" + data,
        params: data
    });
};

// --------------------房客管理--------------------
// 列表查询
export const getTenantAjax = data => {
    return request({
        method: "GET",
        url: "/develop/customer/list",
        params: data
    });
};
//导入房客列表
export const importTenantExcel=data=>{
    return request({
        url: `/develop/customer/import-tenant-excel`,
        method: "post",
        headers:{
            'Content-Type': 'multipart/form-data'
        },
        data: data
    });
}

// 查询房客详细
export const TenantDetailsAjax = customerId => {
    return request({
        url: "/develop/customer/list/" + customerId,
        method: "get"
    });
};
// 新增房客
export const TenantcustomerAjax = data => {
    return request({
        url: "/develop/customer",
        method: "post",
        data
    });
};
// 修改房客状态
export const TenantChangeStatus = data => {
    return request({
        url: "/develop/customer",
        method: "PUT",
        data: data
    });
};
// 删除房客状态
export const TenantDelete = data => {
    return request({
        url: "/develop/customer/list/" + data,
        method: "DELETE"
    });
};

// --------------------房东管理--------------------
// 房东列表
export const getLandlordAjax = data => {
    return request({
        method: "GET",
        url: "/develop/hourseLoad/list",
        params: data
    });
};
// 查询房东详细
export const LandlordAjax = data => {
    return request({
        url: `/develop/hourseLoad/list/${data.customerId}/${data.pageSize}/${data.pageNum}`,
        method: "GET"
    });
};

//删除房源
export const deleteHouse = data => {
    return request({
        url: '/develop/hourse/deleteHouse',
        method: "post",
        data
    });
};

//导入房东列表
export const importLandExcel=data=>{
    return request({
        url: `/develop/customer/import-land-excel`,
        method: "post",
        headers:{
            'Content-Type': 'multipart/form-data'
        },
        data: data
    });
}
// 沟通日志回复

export const replyAjax = data => {
    return request({
        url: "/develop/hourseLoad/insertHourLog",
        method: "post",
        data
    });
};
// 修改房东状态
export const customerChangeStatus = data => {
    return request({
        url: `/develop/customer`,
        method: "PUT",
        data: data
    });
};
// 获取运营管家树形数据
export const LandlordTreeselectListsAjax = data => {
    return request({
        method: "GET",
        url: "/system/dept/treeselect",
        params: data
    });
};
// 分配给运营管家
export const hourseLoadChangeStatus = data => {
    return request({
        url: `/develop/hourseLoad/changeStatus`,
        method: "PUT",
        data: data
    });
};
// --------------------会员列表--------------------
export const getlistVip = data => {
    return request({
        method: "GET",
        url: "/vip/listVip",

        // headers: {
        //   Authorization:
        //     "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImJiZGU3ZDg3LTJmMjAtNDA3Yi05NzRmLTQ4NDg4NTI2OGZiMCJ9.6iY8sVwVpe_GHpYFg0Qg9PhRXmltu348hbvf8M2nGnlpNqO7ggi982WvTMQT8jvikcp_8prLTkFN3N466__2Ww"
        // },
        params: data
    });
};
// --------------------修改会员信息--------------------
export const getupdateVipInfo = data => {
    return request({
        method: "POST",
        url: "/vip/updateVipInfo",
        // headers: {
        //   Authorization:
        //     "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImJiZGU3ZDg3LTJmMjAtNDA3Yi05NzRmLTQ4NDg4NTI2OGZiMCJ9.6iY8sVwVpe_GHpYFg0Qg9PhRXmltu348hbvf8M2nGnlpNqO7ggi982WvTMQT8jvikcp_8prLTkFN3N466__2Ww"
        // },
        data
    });
};
// --------------------vip变更记录--------------------
export const getlistVipInfoChange = data => {
    return request({
        method: "GET",
        url: "/vip/listVipInfoChange",
        // headers: {
        //   Authorization:
        //     "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImJiZGU3ZDg3LTJmMjAtNDA3Yi05NzRmLTQ4NDg4NTI2OGZiMCJ9.6iY8sVwVpe_GHpYFg0Qg9PhRXmltu348hbvf8M2nGnlpNqO7ggi982WvTMQT8jvikcp_8prLTkFN3N466__2Ww"
        // },
        params: data
    });
};
// --------------------审核列表--------------------
export const getvipApprove = data => {
    return request({
        method: "GET",
        url: "/vip/listVipApply",
        // headers: {
        //   Authorization:
        //     "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImJiZGU3ZDg3LTJmMjAtNDA3Yi05NzRmLTQ4NDg4NTI2OGZiMCJ9.6iY8sVwVpe_GHpYFg0Qg9PhRXmltu348hbvf8M2nGnlpNqO7ggi982WvTMQT8jvikcp_8prLTkFN3N466__2Ww"
        // },
        params: data
    });
};
// --------------------vip审核--------------------
export const getviplistApprove = data => {
    return request({
        method: "POST",
        url: "/vip/vipApprove",
        // headers: {
        //   Authorization:
        //     "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImJiZGU3ZDg3LTJmMjAtNDA3Yi05NzRmLTQ4NDg4NTI2OGZiMCJ9.6iY8sVwVpe_GHpYFg0Qg9PhRXmltu348hbvf8M2nGnlpNqO7ggi982WvTMQT8jvikcp_8prLTkFN3N466__2Ww"
        // },
        data
    });
};
// --------------------房源管理--------------------
// 房源列表模块
export const hourselist = data => {
    return request({
        url: "/develop/hourse/list",
        method: "GET",
        params: data
    });
};
// 地图房源列表

export const hourselistMap = data => {
    return request({
        url: "/develop/hourse/list1",
        method: "GET",
        params: data
    });
};
// 地图城市列表
export const hourselistCity = data => {
    return request({
        url: "/develop/hourse/list2",
        method: "GET",
        params: data
    });
};

// 分配房源给运营管家
export const manySteward = data => {
    return request({
        url: `/develop/hourse/manySteward`,
        method: "PUT",
        data: data
    });
};
// 查询房东列表
export const selectHourseLoadlist = data => {
    return request({
        url: "/develop/hourse/selectHourseLoad",
        method: "GET",
        params: data
    });
};
// 修改已发布房源信息
export const updateHouseExamine = data => {
    return request({
        url: `/develop/examine/updateHouseExamine`,
        method: "PUT",
        data: data
    });
};
// -------------------发布房源--------------------
// 获取房间配置信息
export const configList = data => {
    return request({
        url: "/develop/config/configList",
        method: "GET",
        params: data
    });
};

// 第一页面保存
export const publishOne = data => {
    return request({
        url: "/develop/hourse/publishOne",
        method: "post",
        data
    });
};
// 第二页面保存
export const publishTwoAjax = data => {
    return request({
        url: "/develop/hourse/publishTwo",
        method: "post",
        data
    });
};
// 第三个页面保存
export const publishThreeAjax = data => {
    return request({
        url: "/develop/hourse/publishThree",
        method: "post",
        data
    });
};
// 第四个页面保存
export const publishFourAjax = data => {
    return request({
        url: "/develop/hourse/publishFour",
        method: "post",
        data
    });
};
// 第五个页面保存
export const publishFiveAjax = data => {
    return request({
        url: "/develop/hourse/publishFive",
        method: "post",
        data
    });
};
// -------------------房源详情-------------------
export const hourseInfo = data => {
    return request({
        url: "/develop/hourse/list/" + data,
        method: "GET"
    });
};
// 入住须知
export const houseConfigList = data => {
    return request({
        url: "/develop/config/houseConfigList",
        method: "GET",
        data
    });
};
// 删除房源
export const DeleteHourse = data => {
    return request({
        url: "/develop/hourse",
        method: "DELETE",
        data
    });
};
// 新建房源
export const houseChannel = data => {
    return request({
        url: "/develop/houseChannel",
        method: "post",
        data: data
    });
};
//修改房源渠道
export const houseChannelChange = data => {
    return request({
        url: "/develop/houseChannel",
        method: "PUT",
        data: data
    });
};
// 查询房源渠道
export const houseChannelInfo = data => {
    return request({
        url: "/develop/houseChannel/info",
        method: "post",
        data
    });
};
// 悠家下架房源
export const offShelf = data => {
    return request({
        url: "/develop/houseChannel/offShelf",
        method: "PUT",
        data: data
    });
};
// ----------------------房源规格-----------------
// 获取房源规格列表
export const configListAjax = data => {
    return request({
        url: "/develop/config/configList",
        method: "GET",
        params: data
    });
};
// 新建配置菜单
export const insertConfigAjax = data => {
    return request({
        url: "/develop/config/insertConfig",
        method: "PUT",
        data
    });
};
// 查询配置菜单详情
export const insertConfigQueryAjax = data => {
    return request({
        url: "develop/config/configList/" + data,
        method: "get"
    });
};
// 修改配置菜单
export const updateConfigAjax = data => {
    return request({
        url: "develop/config/updateConfig",
        method: "post",
        data: data
    });
};
// 删除配置菜单
export const configListDelete = data => {
    return request({
        url: "/develop/config/" + data,
        method: "DELETE"
    });
};
// 配置菜单状态修改
export const insertConfigchange = (iConfigId, iConfigStatus) => {
    const data = {
        iConfigId,
        iConfigStatus
    };
    return request({
        url: "develop/config/updateConfig",
        method: "post",
        data: data
    });
};
//----------------------地址配置管理模块-----------------

//房源城市
export const map_Landmark = data => {
    return request({
        url: "/mapLandmark/getProvinceCityCounty",
        method: "GET",
        params: data
    });
};
//添加地段数据
export const add_MapLandmark = data => {
    return request({
        url: "/mapLandmark/addMapLandmark",
        method: "POST",
        data: data
    });
};
//删除地段数据
export const delete_MapLandmark = data => {
    return request({
        url: "/mapLandmark/deleteMapLandmark",
        method: "DELETE",
        params: data
    });
};
//获取配置数据
export const get_Config = data => {
    return request({
        url: "/mapLandmark/getConfig",
        method: "GET",
        params: data
    });
};
//获取地段信息
export const get_MapLandmark = data => {
    return request({
        url: "/mapLandmark/getMapLandmark",
        method: "POST",
        params: data
    });
};
//修改地段信息
export const update_MapLandmark = data => {
    return request({
        url: "/mapLandmark/updateMapLandmark",
        method: "PUT",
        data: data
    });
};
//调用百度地图API更新数据
export const update_MapLandmarkApi = data => {
    return request({
        url: "/mapLandmark/updateMapLandmarkApi",
        method: "POST",
        params: data
    });
};
// --------------房屋详细--------------------
// 获取房屋详情
export const houseListInfo = data => {
    return request({
        url: "develop/hourse/listInfo",
        method: "GET",
        params: data
    });
};
// --------------房态管理--------------------------
// 房源列表
export const houseState = (data, status) => {
    return request({
        url: `/develop/houseState/list/${data.pageNum}/${data.pageSize}`,
        method: "GET",
        params: status
    });
};
// 修改房态
export const updateHouseStatus = data => {
    return request({
        url: "/develop/houseState/updateHouseStatus",
        method: "post",
        data
    });
};
// 修改房源昵称
export const updateHouseNickName = data => {
    return request({
        url: "/develop/houseState/updateHouseNickName",
        method: "post",
        data
    });
};
// 新建订单
export const RoomaddOrders = data => {
    return request({
        url: "/develop/houseState/addOrders",
        method: "post",
        data
    });
};
//

// 一键改价

export const fastUpdatePrice = data => {
    return request({
        url: "/develop/houseState/fastUpdatePrice",
        method: "post",
        data
    });
};
// 获取房源和订单详情

export const getOrdersOrHouse = data => {
    return request({
        url: `/develop/order/getOrdersOrHouse`,
        method: "GET",
        params: data
    });
};
//导入房源列表
export const importExcel=data=>{
    return request({
        url: `/develop/customer/import-excel`,
        method: "post",
        headers:{
            'Content-Type': 'multipart/form-data'
        },
        data: data
    });
}
//导出房源列表
export const exportHourseExcel=data=>{
    return request({
        url: `/develop/hourse/exportHourseExcel`,
        method: "post",
        data: data
    });
}
//条件查询房东
export const landlordSearch=data=>{
    return request({
        url: `/develop/hourseLoad/landlordSearch`,
        method: "get",
        params: data
    });
}
// ------------------房价管理-----------------
export const housePrice = (data, status) => {
    return request({
        url: `/develop/houseState/housePrice/${data.year}/${data.month}/${data.Num}/${data.pageSize}/${data.pageNum}`,
        method: "GET",
        params: status
    });
};
// ------------------房源审核--------------------
// 房源审核列表
export const hourseAudit = data => {
    return request({
        url: "/develop/hourse/list",
        method: "GET",
        params: data
    });
};
// 房源审核详情
export const hourseAuditList = data => {
    return request({
        url: "/develop/hourse/list/" + data,
        method: "GET"
    });
};
//房源审核标签

export const examineLabel = data => {
    return request({
        url: "/develop/examine/examineLabel/" + data,
        method: "GET"
    });
};
// 修改审核状态
export const examineChange = data => {
    return request({
        url: "/develop/examine",
        method: "PUT",
        data: data
    });
};
// ------------订单列表------------
// 订单列表详情

export const getOrders = data => {
    return request({
        url: "/develop/order/getOrders",
        method: "GET",
        params: data
    });
};

//导入订单列表
export const importOrdersExcel=data=>{
    return request({
        url: `/develop/customer/import-orders-excel`,
        method: "post",
        headers:{
            'Content-Type': 'multipart/form-data'
        },
        data: data
    });
}
// 获取订单详情
export const getOrdersDetails = data => {
    return request({
        url: "/develop/order/getOrdersDetails",
        method: "GET",
        params: data
    });
};
//订单退款
export const wxRefund = data => {
    return request({
        url: "/develop/order/wxRefund",
        method: "GET",
        params: data
    });
};
// 修改订单状态
export const updateOrders = data => {
    return request({
        url: "/develop/order/updateOrders",
        method: "PUT",
        data: data
    });
};
//---------------即时通讯----------------
//获取聊天列表
export const getChatLogListPC = (data,params) => {
    //"/develop/order/getChatLogListPC/" + data+params,
    //getNewChatLogListPC/1?pageSize=10&currentPage=1
    return request({
        url: '/develop/order/getNewChatLogListPC/'+data+params,
        method: "GET"
    });
};
//获取聊天记录
export const getChatLogPC = data => {
    return request({
        url: "/develop/order/getChatLogPC",
        method: "GET",
        params: data
    });
};
// 查询房源信息
export const getHouse = data => {
    return request({
        url: "/develop/order/getHouse/" + data,
        method: "GET"
    });
};
//发送消息
export const sendToMqttPC = data => {
    return request({
        url: "/develop/order/sendToMqttPC",
        method: "post",
        data
    });
};
//获取消息总数
export const countNumPC = data => {
    return request({
        url: "/develop/order/countNumPC",
        method: "GET",
        data
    });
};

//获取订阅主题
export const getTopicPC = data => {
    return request({
        url: "/develop/order/getTopicPC",
        method: "GET",
        data
    });
};
//----------------途家对接-----------------
//添加途家房源
export const addTjHousing  = data => {
    return request({
        url: "/TJ/hotel",
        method: "POST",
        data: data
    });
}
// 修改途家门店信息
export const updateTJStore = data => {
    return request({
        url: "/TJ/updateTJStore",
        method: "PUT",
        data
    });
};
//途家门店列表
export const getStore = data => {
    return request({
        url: "/TJ/getStore",
        method: "GET",
        params: data
    });
};
//查询途家门店详情
export const getStoreHid = data => {
    return request({
        url: "/TJ/getStoreHid",
        method: "GET",
        params: data
    });
}

//同步途家房源
export const synchronization  = params => {
    return request({
        url: "/TJ/synchronization",
        method: "get",
        params
    });
}
    //回复途家消息
 export const replyTjMessage  = data => {
        return request({
            url: "/TJ/replyMessage",
            method: "post",
            data
        });
}
//批量上架下架
export const unitstatus  = data => {
    return request({
        url: "/TJ/unitstatus",
        method: "POST",
        data: data
    });
}
export const queryHouseInfo  = data => {
    return request({
        url: "/TJ/queryHouseInfo?unitIds="+data.unitIds,
        method: "POST",
        // params: data
    });
}
export const getDataStatus  = data => {
    return request({
        url: "/TJ/getDataStatus",
        method: "POST",
        data: data
    });
}
//修改房价Or库存
export const inventory  = data => {
    return request({
        url: "/TJ/inventory",
        method: "POST",
        data: data
    });
}
//发送客服消息
export const merchantmsg  = data => {
    return request({
        url: "/TJ/merchantmsg",
        method: "POST",
        data: data
    });
}
export const replyMessage  = data => {
    return request({
        url: "/TJ/replyMessage",
        method: "POST",
        data: data,
    });
}
//查询当前房源价格房态
export const getInventory  = params => {
    return request({
        url: "/TJ/getInventory",
        method: "get",
        params
    });
}
//修改订单状态
export const updateTjOrderstatus  = data => {
    return request({
        url: "/TJ/orderstatus",
        method: "post",
        data
    });
}

//----------------小猪对接-----------------
export function pigOnlineHousing(data) {
    //上线小猪房源
    return request({
        url: "/develop/pig/onlineHousing?housingId="+data.housingId+"&id="+data.id,
        method: "POST",
        headers: {
            'content-type': 'application/json'
        },

    })
}
export function pigUnitOnline(data) {
    //下线小猪房源
    return request({
        url: "/develop/pig/unitOnline?housingId="+data.housingId+"&id="+data.id+"&state="+data.state,
        method: "POST",
        headers: {
            'content-type': 'application/json'
        },
        //data
    })
}
//获取小猪token
export  function  getPigToken(params){
    return request({
        url: "/develop/pig/getToken",
        method: "get",
        params
    })
}
//更新房价
export  function  pigSyncPrice(data){
    return request({
        url: "/develop/pig/syncPrice?id="+data.id,
        method: "post",
        data,
       /* headers: {
            'content-type': 'multipart/form-data'
        },*/

    })
}

//更新房态和库存
export function updateSynStateStock(data){
    return request({
        url: "/develop/pig/synstatestock",
        method: "post",
        data
    })
}
//同步房源信息
export function pigAddModify(data){
    return request({
        url: "/develop/pig/addModify?id="+data.id+"&housingId="+data.housingId,
        method: "get",

    })
}
//小猪发送消息
export function pigSendMsg(data){
    return request({
        url: "/sendMessage",
        method: "post",
        data
    })
}
//获取小猪回调
export function selectExamine(params){
    return request({
        url: "/develop/pig/selectExamine",
        method: "get",
        params
    })
}
//确认小猪订单
export function confirmPigOrder(data){
    return request({
        url: "/xz-api/order/confirm",
        method: "post",
        data
    })
}

//----------------美团对接-----------------

export function addModifyMT(params) {
    //美团添加房源
    params.token = store.state.MT_token
    return request({
        url: "/MT/addModifyProductParam",
        method: "GET",
        params
    })
}

export function addAddress(data) {
    //添加美团地址
    data.token = store.state.MT_token
    return request({
        url: "/MT/addAddress",
        method: "POST",
        headers: {
            'content-type': 'application/json'
        },
        data
    })
}

export function oneGhost(params) {
    // 一键同步
    params.token = store.state.MT_token
    return request({
        url: "/MT/oneGhost",
        method: "GET",
        params
    })
}

export function shelfDown(params) {
    // 美团房源下架
    params.token = store.state.MT_token
    return request({
        url: "/MT/shelfDown",
        method: "GET",
        params
    })
}


export function authorize(params) {
    // 获取美团授权地址
    return request({
        url: "/MT/authorize",
        method: "GET",
        params
    })
}




//------------------美团-----------------

//房态操作
export  function mtOperateRs(data){
    data.token = store.state.MT_token
    // 开房时库存 为1关房0
    data['restNum'] =  data.openStatus


    return request({
        url: "/MT/operateRs",
        method: "POST",
        headers: {
            'content-type': 'application/json'
        },
        data
    })
}
//下架房源
export  function mtShelfDown(data){
    return request({
        url: "/MT/shelfDown",
        method: "get",
        params: data
    })
}

export function refresh(data) {
    data['redirectUri'] =  "https://test.youjiaminsu.cn/dist/auth"
    //刷新令牌
    return request({
        url: "/MT/refresh",
        method: "POST",
        data,
    })
}
//解绑美团授权
export function elRefreshToken(data) {
    //美团重定向地址
    return request({
        url: '/MT/delRefreshToken',
        method: 'post',
        data
    })
}

export function mtRedirectUrl(params) {
    //美团重定向地址
    return request({
        url: '/MT/redirectUrl',
        method: 'get',
        params
    })
}
export function sendMTMsg(data) {
    //美团重定向地址
    data.token = store.state.MT_token
    return request({
        url: '/MT/sendMsg',
        method: 'post',
        data
    })
}
export function cancelMtOrder(data) {
    //美团取消订单

    return request({
        url: '/MT/cancel?token='+store.state.MT_token,
        method: 'post',
        data
    })
}

//同步美团数据到悠家
export function syncMtProduct(params) {
    params.token = store.state.MT_token
    return request({
        url: '/MT/syncMtProduct',
        method: 'get',
        params
    })
}
export function canceledList(data){
    //        url: "/develop/order/orderCancel?pageNum="+data.pageNum+"&pageSize="+data.pageSize+"&type="+data.type+"&flag="+data.flag,
    return request({
        url: "/develop/order/orderCancel",
        method: "get",
        params:data
    })
}
export  function syncPigProduct(params){
    return request({
        url: '/develop/pig/syncPigRoom',
        method: 'get',
        params
    })
}
export function getQrCode(data){
    return request({
        url: '/small/createOQCode',
        method: 'post',
        data
    })
}
export function getUrlLink(data){
    return request({
        url: '/small/getUrlLink',
        method: 'post',
        data
    })
}
export function selectHouseGenerate(data){
    return request({
        url: '/develop/hourse/selectHouseGenerate',
        method: 'post',
        data
    })
}
export function testUrl(data){
    return axios.post(
        '/wxApi/cgi-bin/wxaapp/createwxaqrcode?access_token=66_quosM_wc7o7sR0_Zkaormr93bilGaDdTygWkSFaNALxoMetRlYMiPnTjlgHJ9bkI88ReQSQHIqAqI9u5syEcvLz3YiedeMxDLJWr_ThRYxLsEqZT8C0kA4hDSAgEIEfACAYCY',data,{responseType:"blob"})

}
export function testUrl2(data){
    return axios.post('/fileManagement/file/download/package',data,{ responseType: 'arraybuffer'})

}
export function getAllChannelConnection (params){
    return request({
        url: '/channelConnection',
        method: 'get',
        params
    })
}


export function addChannelConnection(data){
    return request({
        url: '/channelConnection',
        method: 'post',
        data
    })
}


// 读取直连账号房源
export function batchAddRoom(data){
    return request({
        url: '/room/batchAddRoom',
        method: 'post',
        data
    })
}

// 删除直连账号
export function deleteChannelConnection(params){
    return request({
        url: '/channelConnection/'+params,
        method: 'delete',
    })
}

// 渠道直连 查看所有房源
export function findByPage(data,params){
    return request({
        url: '/room/page',
        method: 'post',
        data,
        params
    })
}

// 渠道直连 关联房源
export function correlation(data){
    return request({
        url: '/room/correlation',
        method: 'post',
        data,
    })
}



// 渠道直连 解除关联房源
export function disassociate(params){
    return request({
        url: '/room/disassociate',
        method: 'get',
        params
    })
}

export function sentGzdMsg(data){
    return request({
        url: '/develop/order/sendMsg',
        method: 'post',
        data
    })
}
export function deleteBed(params){
    return request({
        url: '/develop/examine/deleteBed',
        method: 'get',
        params
    })
}
//gcj02经纬度转bd09ll
export function gcj02ToBd09ll(params){
    return axios.get('/baiDuMap/geoconv/v1/',{params});

}
// 解除绑定小猪子账号
export function unbindingPig(params){
    return  request({
        url: '/develop/pig/delAccount',
        method: 'get',
        params
    })

}
// 分配房东
export function updateHouseLandlord(data){
    return  request({
        url: '/wx/allotmentLandlord',
        method: 'post',
        data
    })

}
